import { render, staticRenderFns } from "./InvoiceAddress.vue?vue&type=template&id=325b539c&"
import script from "./InvoiceAddress.vue?vue&type=script&lang=js&"
export * from "./InvoiceAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports